import * as React from "react";

function SvgShelf(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" {...props}>
      <g clipPath="url(#Shelf_svg__clip0)" fill="#fff">
        <path d="M5.939 0h14v2h-14V0zM5.939 22h14v2h-14v-2zM7.939 16h10v1h-10v-1zM7.939 5h10v1h-10V5zM7.939 7h10v1h-10V7zM7.939 18h10v1h-10v-1zM7.939 11h10v2h-10v-2zM5.939 2h2v20h-2V2zM17.939 2h2v20h-2V2zM.939 0h2v24h-2zM22.939 0h2v24h-2z" />
      </g>
      <defs>
        <clipPath id="Shelf_svg__clip0">
          <path d="M.939 0h23.926v24H.939V0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgShelf;
